import {
    Form,
    FormField,
    FormFieldConditions,
    FormSection,
    FormType,
    InputType,
} from '@fitogest/reactive-form-builder/interfaces';
import { ClienteAlbaranModel } from 'src/app/models/ventas/tablas-maestras.model';
import { environment } from 'src/environments/environment';

export class ClienteFormDefinition {
  public readonly appName = environment.appName;
  public lastFieldChanged = '';
  public requestType: FormType = FormType.CREATION;
  public model: Partial<ClienteAlbaranModel> = {};
  public formFields: Form<ClienteAlbaranModel>;

  constructor(type: FormType, model: Partial<ClienteAlbaranModel>) {
    this.requestType = type;
    this.model = model;
    this.formFields = {
      name: 'cliente-albaran',
      header: 'Datos del cliente',
      type: +type as FormType,
      sections: this.getSections(),
      table: null,
      uploadButton: {
        isEnabled: false,
        label: '',
      },
      signed: false,
    };
  }

  public handleFormValueChange(tag: string): void {
    this.lastFieldChanged = tag;
  }

  private getSections(): FormSection<ClienteAlbaranModel>[] {
    return [
      {
        name: '',
        fields: this.getFields(),
        width: 12,
        isVisible: true,
        order: 1,
      },
    ];
  }

  private getFields(): FormField<ClienteAlbaranModel>[] {
    return [
      this.textField('nombre', 'Nombre', 1, true),
      this.textField('alias', 'Alias', 2),
      this.textField('email', 'Email', 3),
      this.textField('direccion', 'Dirección', 4),
      this.textField('localidad', 'Localidad', 5),
      this.textField('provincia', 'Provincia', 6),
      this.textField('telefono', 'Teléfono', 7),
      this.textField('fax', 'Fax', 8),
    ];
  }

  private textField(name: keyof ClienteAlbaranModel & string, label: string, order: number, isRequired = false): FormField<ClienteAlbaranModel> {
    return {
      name,
      label,
      input: {
        type: InputType.TEXT,
        isEditable: true,
      },
      width: 4,
      conditions: this.conditions({ isRequired }),
      order,
    };
  }

  private conditions(overrides: Partial<FormFieldConditions> = {}): FormFieldConditions {
    return {
      isRememberedOnDuplicate: true,
      isRequired: false,
      isRetained: false,
      hasUndoEnabled: false,
      isVisible: true,
      ...overrides,
    };
  }
}
